import { Box, HStack, Image, Tag, Text } from '@chakra-ui/react';
import { GlobalSearchCustomerItem } from '@texas/api/endpoints/search/searchApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { clientEndpoints } from '@texas/clientEndpoints';
import placeholderImg from '@texas/assets/placeholder-50.png';
import { TrackerWrapper } from '@texas/components/shared/tracker/TrackerWrapper';
import { EntityType } from '@texas/api/endpoints/trackerApi';
import { useTranslation } from 'react-i18next';

interface Props {
  customer: GlobalSearchCustomerItem;
  onResultClick: () => void;
}

export function CustomerItem({ customer, onResultClick }: Props) {
  const { t } = useTranslation();

  return (
    <TrackerWrapper entityId={customer.id} entityType={EntityType.Customer}>
      <AngularNavLink
        to="customer"
        navobj={{ customerId: customer.id }}
        onClick={onResultClick}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={2}
        borderRadius="md"
        _hover={{
          bg: 'whiteAlpha.100',
          _light: { bg: 'blackAlpha.100' },
        }}
        textDecoration="none"
      >
        <HStack>
          <Image
            boxSize="12"
            src={
              customer.logoIdentifier
                ? clientEndpoints.previewImage(customer.logoIdentifier, 128)
                : undefined
            }
            fallbackSrc={placeholderImg}
            objectFit="contain"
            borderRadius="md"
            alt={customer.name}
          />
          <Box>
            <HStack>
              <Text fontWeight="bold">{customer.name}</Text>
              {customer.archived && (
                <Tag size="sm" colorScheme="orange">
                  {t('general.archived')}
                </Tag>
              )}
            </HStack>
            {customer.projectNumber && (
              <Text fontSize="sm">{customer.projectNumber}</Text>
            )}
          </Box>
        </HStack>
      </AngularNavLink>
    </TrackerWrapper>
  );
}
